import { programRequestsApi } from '../api/programRequestsApi';
import { toCreateChangeDetailsRequest } from './changeDetailsModel';

export const createChangeDetailsFlow = async ({
    form,
    onError,
    api = programRequestsApi,
}) => Boolean(
    await api.createChangeDetailsRequest(toCreateChangeDetailsRequest(form), onError)
);
